"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import $ from "jquery";
import _ from "underscore";
import classNames from "classnames";
import CarrierService from "../../services/carrier_service";
import generalFormatter from "../../formatters/general";
import "../../formatters/carrier_invoice";
import CarrierName from "../carrier_name";
import "../../api/api";
import Account from "../../api/account";
import { Table } from "../ui/v3/table";
import { Button, ButtonSize, ButtonVariant } from "../ui/v3/button";
import { StatusTag, StatusTagStyle, StatusTagSize } from "../ui/v3/status_tag";
import { push } from "../app_history";
function toStatusTagStyle(invoice) {
  switch (invoice.status) {
    case "Paid":
    case "Approved":
    case "Complete":
    case "Processed":
      return StatusTagStyle.Success;
    case "Received":
      return StatusTagStyle.Info;
    case "Incomplete":
    case "Waiting":
    case "Reply":
    case "Exception":
      return StatusTagStyle.Warning;
    case "Deleted":
    case "Ignored":
    case "Moved to TMS":
      return StatusTagStyle.Alert;
    default:
      return StatusTagStyle.Default;
  }
}
function isAbandoned(invoice) {
  return invoice.state === "abandoned";
}
function invoices(props) {
  return props.carrierInvoices || props.factorInvoices;
}
function possibleFuelAdvanceHeader(props) {
  if (hasFuelAdvances(props)) {
    return /* @__PURE__ */ jsx("th", { children: "Fuel Advance?" });
  }
}
function possibleFuelAdvance(props, invoice) {
  if (hasFuelAdvances(props)) {
    return /* @__PURE__ */ jsx("td", { children: invoice.fuel_advance ? "Yes" : "No" });
  }
}
function isCurrent(props, invoice) {
  return invoice.id === props.currentInvoice.id;
}
function hasFuelAdvances(props) {
  return isFactorInvoices(props);
}
function isFactorInvoices(props) {
  return !!props.factorInvoices;
}
function isCarrierInvoices(props) {
  return !!props.carrierInvoices;
}
function linkForInvoice(props, invoice) {
  if (isCarrierInvoices(props)) {
    return {
      location: props.location.pathname.replace(
        /carrier_invoices\/(\d+)/,
        "carrier_invoices/" + invoice.id
      )
    };
  } else {
    const newParams = _.omit(props.location.query, "factorInvoiceId");
    const currentPath = props.location.pathname;
    var batchId = 0;
    const pMatch = currentPath.match(/index-document-batches\/(\d+)/);
    if (pMatch) {
      batchId = parseInt(pMatch[1]);
    }
    if (currentPath.match(/factor_invoices/)) {
      if (_.some(invoice.document_batch_ids, (id) => id == batchId)) {
        return {
          location: "/index-document-batches/" + batchId,
          query: _.extend(newParams, { factorInvoiceId: invoice.id })
        };
      } else {
        return {
          location: props.location.pathname.replace(
            /factor_invoices\/(\d+)/,
            "factor_invoices/" + invoice.id
          ),
          query: newParams
        };
      }
    }
    return {
      location: currentPath + "/factor_invoices/" + invoice.id,
      query: newParams
    };
  }
}
function headerForInvoices(props) {
  if (isCarrierInvoices(props)) {
    return "Carrier Invoices";
  } else {
    return "Invoices";
  }
}
function headerForInvoicesV3Reskin(props) {
  if (isCarrierInvoices(props)) {
    return "Carrier invoices";
  } else {
    return "Invoices";
  }
}
function renderV3Reskin(props) {
  var ordered = _(invoices(props)).chain().sortBy((invoice) => {
    return CarrierService.getCarrierOrUnknown(invoice.carrier_id).name;
  }).reverse().sortBy("created_at").value();
  const possibleFuelAdvanceCol = hasFuelAdvances(props) && {
    heading: "Fuel advance?",
    content: (invoice) => invoice.fuel_advance ? "Yes" : "No"
  };
  const columns = [
    {
      heading: "Invoice",
      content: (invoice) => invoice.number || invoice.source_invoice_number || "N/A"
    },
    possibleFuelAdvanceCol,
    {
      heading: "Total",
      content: (invoice) => generalFormatter.currency(
        invoice.amount_to_pay || invoice.source_invoice_amount
      )
    },
    {
      heading: "Carrier",
      content: (invoice) => /* @__PURE__ */ jsx(
        CarrierName,
        {
          carrierID: invoice.carrier_id,
          includeExternalVendorId: true
        }
      )
    },
    {
      heading: "Process date",
      content: (invoice) => generalFormatter.shortDate(invoice.created_at)
    },
    {
      heading: Account.auditBillingEnabled() ? "Invoice status" : "Status",
      content: (invoice) => /* @__PURE__ */ jsx(
        StatusTag,
        {
          content: invoice.status,
          style: toStatusTagStyle(invoice),
          size: StatusTagSize.Small
        }
      )
    },
    {
      heading: "",
      content: (invoice) => viewButtonV3Reskin(props, invoice)
    }
  ].filter((column) => column !== false);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: "var(--space-s)"
      },
      children: [
        /* @__PURE__ */ jsx("h3", { children: headerForInvoicesV3Reskin(props) }),
        /* @__PURE__ */ jsx(Table, { columns, rows: ordered })
      ]
    }
  );
}
function viewButton(props, invoice) {
  var buttonText = "View";
  var newLocation = linkForInvoice(props, invoice);
  var classes = "button--confirmation load-detail__invoice-table-button";
  if (isCurrent(props, invoice)) {
    buttonText = "Viewing";
    classes = classes + " button--disabled";
  }
  return /* @__PURE__ */ jsx(
    "a",
    {
      href: newLocation.location + (newLocation.query ? "?" + $.param(newLocation.query) : ""),
      className: classes,
      disabled: isCurrent(props, invoice),
      onClick: (e) => {
        viewInvoice(props, e, invoice);
      },
      children: buttonText
    }
  );
}
function viewButtonV3Reskin(props, invoice) {
  const buttonText = isCurrent(props, invoice) ? "Viewing" : "View";
  const newLocation = linkForInvoice(props, invoice);
  let href = newLocation.location + (newLocation.query ? "?" + $.param(newLocation.query) : "");
  let onClick = (e) => viewInvoice(props, e, invoice);
  let disabled;
  if (isCurrent(props, invoice)) {
    onClick = () => {
    };
    href = void 0;
    disabled = true;
  }
  return /* @__PURE__ */ jsx(
    Button,
    {
      size: ButtonSize.Medium,
      variant: ButtonVariant.Text,
      disabled,
      onClick,
      href,
      children: buttonText
    }
  );
}
function viewInvoice(props, e, invoice) {
  e.preventDefault();
  var newLocation = linkForInvoice(props, invoice);
  push(newLocation.location, newLocation.query || props.location.query);
}
function showInvoice(props, invoice, index) {
  var classes = classNames({
    "load-detail__invoice-table-current-invoice": isCurrent(props, invoice),
    "load-detail__invoice-table-abandoned-invoice": isAbandoned(invoice)
  });
  return /* @__PURE__ */ jsxs("tr", { className: classes, children: [
    /* @__PURE__ */ jsx("td", { children: invoice.number || invoice.source_invoice_number || "N/A" }),
    possibleFuelAdvance(props, invoice),
    /* @__PURE__ */ jsx("td", { children: generalFormatter.currency(
      invoice.amount_to_pay || invoice.source_invoice_amount
    ) }),
    /* @__PURE__ */ jsx("td", { className: "load-detail__invoice-table-carrier", children: /* @__PURE__ */ jsx(
      CarrierName,
      {
        carrierID: invoice.carrier_id,
        includeExternalVendorId: true
      }
    ) }),
    /* @__PURE__ */ jsx("td", { children: generalFormatter.shortDate(invoice.created_at) }),
    /* @__PURE__ */ jsx("td", { children: invoice.status }),
    /* @__PURE__ */ jsx("td", { children: viewButton(props, invoice) })
  ] }, "invoice-" + index);
}
function PreviousInvoiceInformation(props) {
  if (props.v3ReskinEnabled) return renderV3Reskin(props);
  var ordered = _(invoices(props)).chain().sortBy((invoice) => {
    return CarrierService.getCarrierOrUnknown(invoice.carrier_id).name;
  }).reverse().sortBy("created_at").value();
  const statusLabel = Account.auditBillingEnabled() ? "Carrier Invoice Status" : "Status";
  return /* @__PURE__ */ jsxs("div", { "data-component": "PreviousInvoiceInformation", children: [
    /* @__PURE__ */ jsx("h3", { className: "load-detail__section-header", children: headerForInvoices(props) }),
    /* @__PURE__ */ jsxs("table", { className: "load-detail__info-table load-detail__previous-invoices", children: [
      /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsxs("tr", { className: "load-detail__info-table-header", children: [
        /* @__PURE__ */ jsx("th", { children: "Invoice #" }),
        possibleFuelAdvanceHeader(props),
        /* @__PURE__ */ jsx("th", { children: "Total" }),
        /* @__PURE__ */ jsx("th", { children: "Carrier" }),
        /* @__PURE__ */ jsx("th", { children: "Process Date" }),
        /* @__PURE__ */ jsx("th", { children: statusLabel }),
        /* @__PURE__ */ jsx("th", { children: "\xA0" })
      ] }) }),
      /* @__PURE__ */ jsx("tbody", { children: _.map(
        ordered,
        (invoice, index) => showInvoice(props, invoice, index)
      ) })
    ] })
  ] });
}
export default PreviousInvoiceInformation;
